export default "__VITE_ASSET__cdbafbc0__"